import { EventTile } from "../../../../components/analysis/tiles";
import {
  Grid,
  Box,
  TablePagination,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import QuickSearch from "../../../../components/analysis/quickSearch";
import { useGlobal } from "../../../../context/GlobalProvider";

export default function AnalysisEventSearch() {
  const { eventList, teamList } = useGlobal();
  const [eventLowerBound, setEventLowerBound] = useState(0);
  const [eventsShown, setEventsShown] = useState(12);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [chosenRegion, setChosenRegion] = useState("all");

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    setEventLowerBound(newPage * eventsShown);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(
      Math.floor(page * (eventsShown / parseInt(event.target.value, 10)))
    );
    setEventsShown(parseInt(event.target.value, 10));
    setEventLowerBound(
      Math.floor(page * (eventsShown / parseInt(event.target.value, 10))) *
        parseInt(event.target.value, 10)
    );
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setPage(0);
    setEventLowerBound(0);
  };

  useEffect(() => {
    setPage(0);
  }, []);

  const handleDistrictChange = (district) => {
    setChosenRegion(district);
    setPage(0);
    setEventLowerBound(0);
  };

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={2}
        sx={{
          display: { xs: "flex", sm: "none" },
          justifyContent: "left",
          alignContent: "top",
        }}
      >
        <QuickSearch events={eventList} teams={teamList} />
      </Grid>
      <Grid item xs={10} sm={12} md={8} lg={4}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "right", sm: "center", lg: "left" },
            pb: 2,
          }}
        >
          <TextField
            name="searchTeam"
            label="Search"
            variant="filled"
            sx={{ width: "90%" }}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
          <FormControl fullWidth>
            <InputLabel sx={{ top: 13 }}>District</InputLabel>
            <Select
              variant="filled"
              value={chosenRegion}
              label="District"
              onChange={(e) => handleDistrictChange(e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "background.main",
                  },
                },
              }}
            >
              <MenuItem value={"all"}>Every District</MenuItem>
              <MenuItem value={"chs"}>Chesapeake</MenuItem>
              <MenuItem value={"fin"}>Indiana</MenuItem>
              <MenuItem value={"isr"}>Israel</MenuItem>
              <MenuItem value={"fim"}>Michigan</MenuItem>
              <MenuItem value={"fma"}>Mid-Atlantic</MenuItem>
              <MenuItem value={"ne"}>New England</MenuItem>
              <MenuItem value={"fnc"}>North Carolina</MenuItem>
              <MenuItem value={"ont"}>Ontario</MenuItem>
              <MenuItem value={"pnw"}>Pacific Northwest</MenuItem>
              <MenuItem value={"pch"}>Peach Tree</MenuItem>
              <MenuItem value={"fsc"}>South Carolina</MenuItem>
              <MenuItem value={"fit"}>Texas</MenuItem>
              <MenuItem value={"no"}>Other</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6}>
        <Box sx={{ display: "flex", justifyContent: "right" }}>
          <TablePagination
            count={
              eventList.filter((event) => {
                const { label, location, value, week, district } = event;

                const cleanSearch = (search ?? "")
                  .toLowerCase()
                  .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

                const matchesSearch = [label, location, value, week].some(
                  (field) =>
                    (field ?? "")
                      .toLowerCase()
                      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                      .includes(cleanSearch)
                );

                return (
                  matchesSearch &&
                  (district === "" ? "no" : district).includes(
                    chosenRegion === "all" ? "" : chosenRegion
                  ) &&
                  event.week != "Testing"
                );
              }).length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={eventsShown}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[12, 24, 48]}
            sx={{ bgcolor: "#444", borderRadius: 5, scrollbarWidth: "none" }}
            labelRowsPerPage="Events Per Page"
          />
        </Box>
      </Grid>
      {eventList
        .filter((event) => {
          const { label, location, value, week, district } = event;

          const cleanSearch = (search ?? "")
            .toLowerCase()
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

          const matchesSearch = [label, location, value, week].some((field) =>
            (field ?? "")
              .toLowerCase()
              .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
              .includes(cleanSearch)
          );

          return (
            matchesSearch &&
            (district === "" ? "no" : district).includes(
              chosenRegion === "all" ? "" : chosenRegion
            ) &&
            event.week != "Testing"
          );
        })
        .slice(eventLowerBound, eventLowerBound + eventsShown)
        .map((event) => (
          <EventTile key={event.value} event={event} />
        ))}
    </Grid>
  );
}
